import { Layout } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';

const { Sider } = Layout;

const SankhyaSideMenu: React.FC<{ authDomain: string }> = ({ authDomain }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const basename = '/' + window.location.pathname.split('/')[1];

  const handleIFrameMessage = useCallback(
    (event: MessageEvent) => {
      const allowedOrigins = [authDomain ? new URL(authDomain).origin : null].filter(Boolean);

      if (!allowedOrigins.includes(event.origin)) {
        console.warn('Mensagem de origem não confiável:', event.origin);
        return;
      }

      if (event.data?.data?.extra !== undefined) {
        setCollapsed(event.data.data?.extra?.collapsed ?? true);
        setIsLoading(event.data.data?.extra?.isLoading ?? true);
      }

      if (event.data.type === 'NAVIGATE_TO_SYSTEM') {
        window.location.href = event.data.data.url;
      }
    },
    [authDomain]
  );

  // Listen for messages from the iframe
  useEffect(() => {
    window.addEventListener('message', handleIFrameMessage);

    return () => {
      window.removeEventListener('message', handleIFrameMessage);
    };
  }, [handleIFrameMessage]);

  return (
    <Sider
      ref={iframeRef}
      width={256}
      collapsedWidth={64}
      collapsed={collapsed}
      style={{
        overflow: 'hidden',
        height: '100%',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        backgroundColor: '#fff',
        boxShadow: '2px 0 6px rgba(0,0,0,0.1)',
        zIndex: 1000,
      }}
    >
      <iframe
        hidden={isLoading}
        id="sankhya-menu-iframe"
        title="side-menu"
        style={{
          height: '100%',
          border: 'none',
          position: 'absolute',
          left: 0,
          top: 0,
        }}
        src={`${authDomain}${basename.slice(1)}/side_menu_sankhya/?original_name=ats`}
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-popups-to-escape-sandbox"
        frameBorder="0"
        allowFullScreen
      />
    </Sider>
  );
};

export default SankhyaSideMenu;
